import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { PageContext } from "../../../../Context/PageContext";
import { ApiConnectTicketAnswerListRequest, ApiConnectTicketListRequest } from "../../../../api/LionsUserApiConect";
import TicketPanelIcon from "../meucadastro/img/ticket.png"
import { OpenPopMenu } from "../../../../PopMenuWindow/PopMenuWindow";
import PopUpImg from "../img/wallpaper_60_1024.png"
import UserNotLogged from "../UserNotLogged";
import CreateNewTicket from "../meucadastro/CreateNewTicket";

function TicketPanel() {

    const { user, setPage, setIsLogged} = useContext(PageContext);
    const {setPopMenuContent} = useContext(PageContext)

    const [ticketList, setTicketList] = useState([]);
    const [answerList, setAnswerList] = useState([]);

    const [dateRule, setDateRule] = useState("-")
    const [topicRule, setTopicRule] = useState("")
    const [statusRule, setStatusRule] = useState("")


    function openTicketContainer(element) {

        let eTarget = element.target.parentNode.nextSibling;

        if(eTarget.getBoundingClientRect().height === 0){
            element.target.parentNode.nextSibling.style.height = "100%";
        return;
        } else {
            element.target.parentNode.nextSibling.style.height = "0";
        }

    }

    useEffect(() => {
        let result = ApiConnectTicketListRequest(user.userName, user.userEmail)
        result.then((response) => {

            if(response.status == 403 || response.status == 401) {
                setPage(<UserNotLogged/>);
                setIsLogged(false);
                return;
            }
            setTimeout(() => document.getElementById("Master").style.opacity = 1,300)

            let finalResult = ApiConnectTicketAnswerListRequest(response.data).then(
                answerResponse => {
                    setAnswerList(answerResponse);
                });

            setTicketList(response.data);
        });}
        ,[])

    return(
        <MessageContainer id="Master">

                <TitleMaster>
                    <ColumItemHeaderIcon iconImg={TicketPanelIcon}/>
                    <TitleFont>Tickets </TitleFont>
                </TitleMaster>
                
                <MessageHeader>
                    <MessageHeaderItem>
                        <Select onChange={(e) => setTopicRule(e.target.value)}>
                            <Option value="">Tópico</Option>
                            <Option value="Geral">Geral</Option>
                            <Option value="Servidor">Servidor</Option>
                            <Option value="Doações">Doações</Option>
                            <Option value="Acesso VIP">Acesso VIP</Option>
                            <Option value="Denúncias">Denúncias</Option>
                        </Select>
                    </MessageHeaderItem>
    
                    <MessageHeaderItem>
                        <Select onChange={(e) => setDateRule(e.target.value)}>
                            <Option value="-">Data</Option>
                            <Option value="2024">2024</Option>
                            <Option value="2025">2025</Option>
                        </Select>
                    </MessageHeaderItem>

                    <MessageHeaderItem>
                        <Select onChange={(e) => setStatusRule(e.target.value)}>
                            <Option value="">Status</Option>
                            <Option value="Fechado">Respondido</Option>
                            <Option value="Aberto">Aberto</Option>
                            <Option value="Em análise">Em análise</Option>
                        </Select>
                    </MessageHeaderItem>

                </MessageHeader>

                <MessageItemsMaster>
                    {ticketList.map((item) => {
                        if(item.ticketstatus.includes(statusRule) === false){
                            return;
                        }
                        if(item.creationDate.includes(dateRule) === false){
                        return;
                        }

                        if(item.topic.includes(topicRule) === false){
                        return;
                        }

                        let ticketSet =
                        <MasterTicketItem>
                            <MessageItem >
                                <TicketNumberMessageField onClick={
                                    (e) => {
                                OpenPopMenu();
                                setPopMenuContent(
                                    <MasterContainer>
                                     <AnswersMasterContainer>
                                        <h1>Ticket  #{item.requestNumber}</h1>
                                        <TicketDescriptionContainer>
                                            <EventDate>
                                                {item.creationDate.split('T')[0]} - {item.creationDate.split('T')[1]}
                                            </EventDate>
                                            <EventStatus>Criado</EventStatus>
                                            <EventSimbol color={"blue"}/>
                                            <CreatorName>{user.userName}</CreatorName>  
                                            <TicketDescription>{item.description}</TicketDescription>
                                        </TicketDescriptionContainer>

                                        { answerList.map((itemAnswer) => {
                                        if(itemAnswer.ticketId == item.ticketId){
                                            return(
                                                <TicketDescriptionContainer>
                                                    <EventDate>
                                                        {itemAnswer.creationDate.split('T')[0]} - {itemAnswer.creationDate.split('T')[1]}
                                                    </EventDate>
                                                    <EventStatus>{itemAnswer.answerStatus}</EventStatus>
                                                    <EventSimbol color={"green"}/>
                                                    <CreatorName>{itemAnswer.replayerName}</CreatorName>  
                                                    <TicketDescription
                                                    readonly >{itemAnswer.description}</TicketDescription>
                                                </TicketDescriptionContainer>
                                            )
                                        } else { return;}
                                             })
                                        }
                                    </AnswersMasterContainer>

                                    <BgPopUp bgp={PopUpImg}/>
                                    </MasterContainer>
                                )
                                    }
                                
                                }
                                    
                                    
                                    >{item.requestNumber}
                                    </TicketNumberMessageField>
                                <MessageField onClick={(e) => e.stopPropagation()}>{item.topic}</MessageField>
                                <MessageField onClick={(e) => e.stopPropagation()}>{item.title}</MessageField>
                                <MessageField onClick={(e) => e.stopPropagation()}>{item.ticketstatus}</MessageField>
                            </MessageItem>


                            <AnswersContainer>
                                <TicketDescriptionContainer>
                                    <EventDate>
                                        {item.creationDate.split('T')[0]} - {item.creationDate.split('T')[1]}
                                    </EventDate>
                                    <EventStatus>Criado</EventStatus>
                                    <EventSimbol color={"blue"}/>
                                    <CreatorName>{user.userName}</CreatorName>  
                                    <TicketDescription>{item.description}</TicketDescription>
                                </TicketDescriptionContainer>

                            </AnswersContainer>
                            
                        </MasterTicketItem>

                        return(ticketSet)
                    })}

                </MessageItemsMaster>

                <AcessoContainerNewAccount>
                                <AcessoItemContainerNewAccount 
                                    onClick={() => {
                                    OpenPopMenu();
                                    setPopMenuContent(<CreateNewTicket/>)}}
                                     >Novo Ticket +</AcessoItemContainerNewAccount>
                            </AcessoContainerNewAccount>
                </MessageContainer>

    )
}

export default TicketPanel;

const MasterContainer = styled.div`
    display: flex;
    border: solid 1px;
    align-items: center;
    background-color: white;
    border-radius: 10px;
    box-shadow: 10px 10px 10px 0 black;
    width: 100%;

    @media(max-width: 1000px) {
      width: 100%;
      padding: 40px 15px;
      //border: solid 1px rgba(0,0,0, .2);
      scale: .7;
    }
`

const MessageContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    //border: solid;
    margin-top: 0px;
    border-radius: 10px;
    //box-shadow: 0 0 10px 0 black;
    padding: 20px 0px;
    max-height: 1000px;
    transition: .5s ease-in-out;
    opacity: 0;
    margin-bottom: 1000px;
    
    @media(max-width: 1000px) {
      width: 90vw;
      padding: 40px 15px;
      //border: solid 1px rgba(0,0,0, .2);
    }

`

const TitleMaster = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    width: 100%;
    border-radius: 10px;
    transition: .3s ease-in-out;
    margin: 30px 0;
    //border: solid;
    background-color: rgba(0,0,0,.7);
    color: white;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    @media(max-width: 1000px) {
      width: 90vw;
      padding: 0 0px;
    }

`

const TitleFont = styled.span`
    font-size: 24pt;
    font-weight: bold;
    margin: 25px 0;

    @media(max-width: 1000px) {
      font-size: 20pt
    }

`

const ColumItemHeaderIcon = styled.div`
    background-image: url(${props => props.iconImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 45px;
    height: 45px;
    margin: 0 55px;
`

const MessageHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 0px 0px;
    width: 100%;
    margin: 10px 0;
    //border: solid;
    //background-color: rgba(0,0,0,.7);

    @media(max-width: 1000px) {
        margin-bottom: 20px;
    }

`

const MessageHeaderItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 12pt;
    transition: .3s ease-in-out;
    padding: 10px 0px;
    margin: 0 25px 0 0;
    border-radius: 5px;
    background-color: rgba(0,0,0,.7);
    color: white;
    width: 200px;

    @media(max-width: 1000px) {
      font-size: 12pt;
    }

`

const MessageItemsMaster = styled.div`
    display: flex:
    flex-direction: column;
    align-items: center;
    //border: solid;
    background-color: rgba(0,0,0,.7);
    width: 100%;
    transition: .3s ease-in-out;
    margin: 20px 0;
    padding: 10px 0;
    border-radius: 10px;
`
const MessageItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 11pt;
    transition: .3s ease-in-out;
    z-index: 2;
    margin: 5px 15px;
    background-color: rgba(0,0,0,.7);
    color: white;
    border-radius: 10px;
    width: 850px;

    &:hover{
        background-color: rgb(32, 106, 151);
        color: white;
    }

    @media(max-width: 1000px) {
      width: 90vw;
    }
`

const MessageField = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    transition: .3s ease-in-out;
    padding: 20px 0px;
    text-align: center;
    //border: solid;
    width: 170px;

    @media(max-width: 1000px) {
      width: 100px;
    }
`
const TicketNumberMessageField = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    transition: .3s ease-in-out;
    padding: 20px 0px;
    text-align: center;
    //border: solid;
    width: 190px;
    font-weight: bold;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover {
    scale: 1.2;

    @media(max-width: 1000px) {
      width: 100px;

      &:hover {
        scale: 1.0;
        }
    }

`

const Select = styled.select`
    border: none;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    font-size: 14pt;
    transition: .3s ease-in-out;
    border-top: solid 1px rgba(0,0,0,.3);
    width: 100%;
    border: none;
    font-weight: bold;
    background-color: transparent;
    color: white;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }
`
const Option = styled.option`
    background-color: rgba(0,0,0,.7);
    color: white;
    
`

const MasterTicketItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: .3s ease-in-out;
    width: 100%;
    
`

const AnswersContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: start;
    transition: .3s ease-in-out;
    overflow: hidden;
    width: 100%;
    height: 0;
    //border: solid;
`

const TicketDescriptionContainer = styled.div`
    display: flex;
    align-items: start;
    padding: 20px 20px;
    justify-content: start;
    //border-radius: 10px;
    //background-color: rgba(0,0,0, .1);
    transition: .3s ease-in-out;
    //border: solid 1px rgba(0,0,0,.2);
    width: 100%;

`

const EventDate = styled.div`
    display: flex;
    justify-content: center;
    align-text: center;
    width: 110px;
    //border: solid 1px;
    margin-right: 4px;
`
const EventStatus = styled.div`
    width: 100px;
    text-align: center;
    //border: solid 1px;
    margin-right: 10px;
`
const EventSimbol = styled.div`
    background-color: ${props => props.color};
    border-radius: 50%;
    width: 20px;
    height: 20px;
    margin-right: 10px;
    border: solid 1px;
`
const CreatorName = styled.span`
    width: 150px;
    text-align: center;
    //border: solid 1px;
    margin-right: 10px;
`

const TicketDescription = styled.div`
    //border: solid 1px;
    width: 400px;
    font-family: arial;
`

const AnswersMasterContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 800px;
    padding: 0px 40px;
    background-color: rgb(255, 255, 255);
    //border: solid 1px;
    border-radius: 10px;
    //box-shadow: 10px 10px 15px 0px black;
    margin-bottom: 30px;
    color: black;
    
`

const BgPopUp = styled.div`
    background-image: url(${props => props.bgp});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 525px;
    height: 730px;
    //border: solid;

    @media(max-width: 1000px) {
      background-image: url('');
      width: 0px;
    }

`

const AcessoContainerNewAccount = styled.div`
    display: flex;
    align-items: center;
    color: white;
    width: 100%;
    height: 50px;
    margin: 10px 0 10px 10px;;
    
`

const AcessoItemContainerNewAccount = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    //border: solid 2px black;
    width: 130px;
    height: 50px;
    opacity: .8;
    text-align: center;
    border-radius: 10px;
    background-color: rgb(26, 144, 67);
    font-size: 12pt;
    font-weight: bold;
    transition: .3s ease-in-out;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover {
    opacity: 1;
    }
`



